module.exports = __webpack_public_path__ + "static/media/plato.9eb0d9f1.svg";